import { render, staticRenderFns } from "./CreditTradeAccounts.vue?vue&type=template&id=0253a5a1&scoped=true&"
import script from "./CreditTradeAccounts.vue?vue&type=script&lang=js&"
export * from "./CreditTradeAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253a5a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0253a5a1')) {
      api.createRecord('0253a5a1', component.options)
    } else {
      api.reload('0253a5a1', component.options)
    }
    module.hot.accept("./CreditTradeAccounts.vue?vue&type=template&id=0253a5a1&scoped=true&", function () {
      api.rerender('0253a5a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Credit/CreditTradeAccounts.vue"
export default component.exports